import { type TokenMap } from './themeToken';

export type Theme = {
  name: string;
  tokenMap: TokenMap;
};

const themeStore: Map<Theme['name'], Theme> = new Map();

export function registerTheme(theme: Theme) {
  themeStore.set(theme.name, theme);
}

export function getTheme(name: Theme['name']) {
  return themeStore.get(name);
}
